import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { appName } from '../../../utils/Variables';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import { notify } from 'react-notify-toast';
import { Helmet } from "react-helmet";
import { Row, Col, Modal, Collapse, Card } from 'react-bootstrap';
import Roles from '../../../utils/Roles';
import PageTitle from '../../../containers/PageTitle';
import ReactFileReader from 'react-file-reader';
import { Cropper } from 'react-image-cropper'
import Toggle from 'react-bootstrap-toggle';
import "react-bootstrap-toggle/dist/bootstrap2-toggle.css";

const styles = {
	cardTitle: {
		paddingBottom: '5px',
		backgroundColor: '#ffd3e7',
		padding: '5px',
		fontSize: '15px',
		fontWeight: '700',
		border: '1px solid grey',
		cursor: 'pointer',
	},
	profileImg: {
		width: '100px',
		border: '1px solid grey',
	},
	expiryStyle: {
		backgroundColor: '#efb6b6',
		padding: '4px'
	}
}

class Renew extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loginId: Sanitize.getData('labUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			saveText: 'Renew',
			isRedirect: false,
			showLoader: false,
			showFullLoader: false,
			showAddModal: false,
			rData: this.props.rData
		}
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
	}

	handleFormSubmit(e) {
		e.preventDefault();
		this.setState({ showLoader: true, saveText: 'Processing..' });
		var formData = Sanitize.objectifyForm($("#frmEmp").serializeArray());
		Reqst.axPost('employee/renew', { token: Reqst.Token(formData) }).then(res => {
			if (res['data'].status == '1') {
				notify.show(res['data'].msg, 'success');
				this.setState({ showLoader: false, saveText: 'Renew' });
				this.props.afterFinish();
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false, saveText: 'Renew' });
			}
		});
	}

	render() {

		let d = this.props.rData;
		var today = new Date();
		var preyear = today.getFullYear() - 2;
		var curyear = today.getFullYear();

		let YearList = [];
		YearList.push(<option value="">Year</option>);
		for (var i = ((new Date()).getFullYear()); i >= ((new Date()).getFullYear() - 1); i--) {
			YearList.push(<option value={i}> {i} </option>);
		}

		return (
			<div>
				<form action="" id="frmEmp" method="post" encType="multipart/form-data" onSubmit={this.handleFormSubmit}>
					<input type="hidden" name="i__lid" value={this.state.loginId} />
					<input type="hidden" name="i__company" value={this.state.companyId} />
					<input type="hidden" name="i__master" value={this.state.masterId} />
					<input type="hidden" name="i__seniority" value={d.seniority} />
					<input type="hidden" name="i__eid" value={d.id} />
					<Row>
						<Col md={12} >
							<Card>
								<Card.Body style={{ padding: 0 }} >
									<Row>
										<Col md={7} style={{ paddingLeft: '20px' }}>
											<table>
												<tbody>
													<tr>
														<td>Name</td>
														<td> : </td>
														<td><b>{d.name}</b></td>
													</tr>
													<tr>
														<td>Dob</td>
														<td> : </td>
														<td>{Sanitize.dmyDash(d.dob)}</td>
													</tr>
													<tr>
														<td>Address</td>
														<td> : </td>
														<td>{d.address} - {d.pincode}</td>
													</tr>
													<tr>
														<td>Mobile</td>
														<td> : </td>
														<td>{d.mobile}</td>
													</tr>
												</tbody>
											</table>
										</Col>
										<Col md={5}>
											<table>
												<tbody>
													<tr>
														<td>Category</td>
														<td> : </td>
														<td>{d.categoryname}</td>
													</tr>
													<tr>
														<td>Qualification</td>
														<td> : </td>
														<td>{d.qualification}</td>
													</tr>
													<tr>
														<td colSpan={3}></td>
													</tr>
													{<tr style={(d.renew_year == null ? d.lastrenew_year : d.renew_year) < preyear ? styles.expiryStyle : { backgroundColor: '' }}>
														<td style={(d.renew_year == null ? d.lastrenew_year : d.renew_year) < preyear ? styles.expiryStyle : { backgroundColor: '' }}>Last Renew</td>
														<td> : </td>
														<td>{d.renew_year == null ? d.lastrenew_year : d.renew_year}</td>
													</tr>}
												</tbody>
											</table>
										</Col>
									</Row>
								</Card.Body>
							</Card>
						</Col>
					</Row>
					{/*(((d.renew_year == null ? d.for_year : d.renew_year) < preyear) || (d.renew_year == null ? d.for_year : d.renew_year) == curyear) ? '' :
						<Row style={{ marginTop: '10px' }}>
							<Col md={4}>
								<label>Renew Year <span className="text-danger">*</span></label>
								<select name="r_year" className="form-control input-sm" required>
									{YearList}
								</select>
							</Col>
							<Col md={4}>
								<label>Renew Date <span className="text-danger">*</span></label>
								<input type="date" name="r_date" className="form-control input-sm" required />
							</Col>
							<Col md={4}>
								<div className="text-right">
									<button style={{ marginTop: '20px' }} type="submit" className="btn btn-success btn-sm" disabled={this.state.saveText != 'Renew'} >
										<i className="fa fa-check"></i> {this.state.saveText}
									</button>
								</div>
							</Col>
		</Row>*/}
				</form>
			</div>
		);
	}

}
export default Renew;